import FormFileInput from '@Components/Form/FormFileInput/FormFileInput';
import { Button } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

const FormFileInputs = () => {
  const formContext = useForm<{
    name: string;
    image: File | null;
  }>({
    mode: 'onTouched',
    defaultValues: {
      name: '',
      image: null,
    },
  });

  const onSubmit = (data: { image: File | null }) => {
    console.log(data.image);
  };

  return (
    <FormProvider {...formContext}>
      <form onSubmit={formContext.handleSubmit(onSubmit)}>
        <FormFileInput
          label="Image Upload Field"
          name="image"
          accept=".jpg, .jpeg, .png"
          helperText={'(ขนาดไม่เกิน 3 MB / .jpeg/ .jpg/ .png)'}
        />
        <Button type="submit">Submit</Button>
      </form>
    </FormProvider>
  );
};

export default FormFileInputs;
